/* @flow */
import reduxThunk from 'redux-thunk'
import {routerMiddleware} from 'react-router-redux'
import history from './createHistory'

import apiCatchErrorMiddleware from './apiCatchErrorMiddleware'

import type {Middleware} from 'redux'
import type {State, Action} from 'modules/Common/types'

const middlewares: Array<Middleware<State, Action<*>>> = [
  apiCatchErrorMiddleware,
  reduxThunk,
  routerMiddleware(history)
]

export default middlewares
